import * as React from "react";
import { Ramp } from "../types";

export interface RampLocation {
  latitude: number;
  longitude: number;
}

/**
 * Hook to extract geographic location from ramp's calibration points
 * Returns the average lat/lng of all calibration points, or null if none exist
 */
export const useRampLocation = (ramp: Ramp | null | undefined): RampLocation | null => {
  return React.useMemo(() => {
    if (!ramp?.calibration_points || ramp.calibration_points.length === 0) {
      return null;
    }

    const points = ramp.calibration_points;
    const sumLat = points.reduce((sum, point) => sum + point.latitude, 0);
    const sumLng = points.reduce((sum, point) => sum + point.longitude, 0);

    return {
      latitude: sumLat / points.length,
      longitude: sumLng / points.length,
    };
  }, [ramp?.calibration_points]);
};
